import {
  FcFinanceCardClasses,
  FinanceCalculatorTheme,
} from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const financeCardStyles = makeStyles<
  FinanceCalculatorTheme,
  object,
  FcFinanceCardClasses
>(
  ({ palette }) => ({
    container: {
      marginTop: 30,
      maxWidth: 450,
    },
    title: {
      marginBottom: 12,
    },
    repaymentContainer: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    baseButton: {
      color: palette.text.secondary,
    },
    deleteButton: {
      marginLeft: 10,
    },
    repaymentAmount: {
      fontWeight: 'bold',
    },
  }),
  {
    name: 'MiniFC_FinanceCard',
  }
)

export default financeCardStyles
